import Navbar from '../../components/feature/Navbar';
import Leadership from '../home/components/Leadership';
import Footer from '../home/components/Footer';

export default function LeadershipPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Page Hero */}
      <section className="relative h-[300px] sm:h-[420px] md:h-[520px] overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/4f6de556197403969fb4a0dfa100501d.jpg"
          alt="組織架構"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/65"></div>
        <div className="relative h-full flex flex-col items-center justify-center text-center px-4 sm:px-6 pt-16 sm:pt-20 w-full">
          <p className="text-xs font-light text-stone-300 tracking-widest uppercase mb-2 sm:mb-3">Organization</p>
          <h1 className="text-3xl sm:text-4xl lg:text-6xl font-black text-white leading-tight mb-3 sm:mb-6 drop-shadow-lg">
            組織架構
          </h1>
          <p className="text-sm sm:text-base lg:text-lg text-white/80 max-w-xl mx-auto leading-relaxed">
            認識 2026 年 YMC Taipei 領導團隊，包含社長、各委員會主委，以及多元精彩的子社團，共同推動社團蓬勃發展。
          </p>
        </div>
      </section>

      {/* Leadership Section */}
      <Leadership />

      <Footer />
    </div>
  );
}
